import { render, staticRenderFns } from "./HasOveralledOrder.vue?vue&type=template&id=060bc330&scoped=true&"
import script from "./HasOveralledOrder.vue?vue&type=script&lang=js&"
export * from "./HasOveralledOrder.vue?vue&type=script&lang=js&"
import style0 from "./HasOveralledOrder.vue?vue&type=style&index=0&id=060bc330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060bc330",
  null
  
)

export default component.exports